export default __webpack_public_path__ + "static/media/Gotham-Medium.a52599fa.otf";